<script setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import ContactsCard from 'dashboard/components-next/Contacts/ContactsCard/ContactsCard.vue';

defineProps({
  contacts: { type: Array, required: true },
});

const router = useRouter();
const route = useRoute();

const expandedCardId = ref(null);

const onClickViewDetails = async id => {
  const routeTypes = {
    contacts_dashboard_segments_index: ['contacts_edit_segment', 'segmentId'],
    contacts_dashboard_labels_index: ['contacts_edit_label', 'label'],
  };
  const [name, paramKey] = routeTypes[route.name] || ['contacts_edit'];
  const params = {
    contactId: id,
    ...(paramKey && { [paramKey]: route.params[paramKey] }),
  };

  await router.push({ name, params, query: route.query });
};

const toggleExpanded = id => {
  expandedCardId.value = expandedCardId.value === id ? null : id;
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div v-for="contact in contacts" :key="contact.id" class="relative">
      <ContactsCard
        :id="contact.id"
        :name="contact.name"
        :email="contact.email"
        :thumbnail="contact.thumbnail"
        :phone-number="contact.phoneNumber"
        :availability-status="contact.availabilityStatus"
        :inbox-ids="contact.inboxIds"
        :assignee-ids="contact.assigneeIds"
        :last-activity-at="contact.lastActivityAt"
        :is-expanded="expandedCardId === contact.id"
        @toggle="toggleExpanded(contact.id)"
        @show-contact="onClickViewDetails"
      />
    </div>
  </div>
</template>
